import React, { useState } from 'react';
import './Form.css';
import logo from '../assets/logo.png';
import RankTable from './RankTable';
import faq from '../assets/faq1.png';

function Form() {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [activeQuestion, setActiveQuestion] = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const response = await fetch(`https://v1039275.macloud.host/rank?prover=@${username}`);
      const data = await response.json();
      if (data.detail === 'Prover not found') {
        setError('Prover not found');
      } else {
        setResult(data);
      }
    } catch (error) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  const toggleQuestion = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

  const faqItems = [
    {
      question: "What does my rank depend on?",
      answer: (
          <div className="faq-image-container">
            <img src={faq} alt="FAQ" className="faq-image" />
          </div>
      )
    },
  ];

  return (
    <div className="form-container">
      <a href="https://testnet.succinct.xyz/" target="_blank" rel="noopener noreferrer">
        <img src={logo} alt="Logo" className="form-logo" />
      </a>
      <h1 className="form-title">
        Check your rank in Succinct Stage 2
        <div className="info-icon" title="Data is taken from the open leaderboard
If you encounter any issues, please wait for a reload
Your profile is not yet in the leaderboard table on the Succinct website">
          <span>!</span>
        </div>
      </h1>
      <p className="form-subtitle">Enter your username exactly as on the leaderboard (without the @ symbol) and see your current position!</p>
      <input 
        type="text" 
        placeholder="Enter your participant name (without @)"
        className="form-input"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <button 
        className="form-button"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? 'Loading...' : 'Send'}
      </button>
      {loading && <div className="loader"></div>}
      {error && <div className="form-error">{error}</div>}
      {result && 
        <div className="result-container">
          <RankTable data={result} />
          <p>Don't forget to join the <span className="team-green">GREEN</span> team for the best experience!</p>
        </div>
      }

      <div className="faq-section">
        <h2 className="faq-title">FAQ: Frequently Asked Questions</h2>
        <div className="faq-container">
          {faqItems.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeQuestion === index ? 'active' : ''}`}
              onClick={() => toggleQuestion(index)}
            >
              <div className="faq-question">
                {item.question}
                <span className="faq-icon">{activeQuestion === index ? '−' : '+'}</span>
              </div>
              <div className="faq-answer">
                {item.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Form; 